/**
 * The caches a finished bulk upload invalidates.
 *
 * One list, because two callers need exactly it: the submit path in
 * useBulkUploadSubmission, and the Tasks page once the run hands off. Keeping a
 * second copy at the call site is how a fifth key gets added in one place and
 * quietly missed in the other.
 *
 * Note what is NOT here: clearSubjectsCache. That belongs to submit alone —
 * submitting can introduce subject-linked data, whereas a feedback run only marks
 * submissions that already exist.
 */
export const BULK_UPLOAD_QUERY_KEYS = [
  'assignments',
  'tasks',
  'submissions',
  'allDocuments',
  'uploadCandidates',
];

export const invalidateBulkUploadQueries = (queryClient) =>
  Promise.all(
    BULK_UPLOAD_QUERY_KEYS.map((key) =>
      queryClient.invalidateQueries({
        queryKey: [key],
        refetchType: 'active',
      })
    ),
  );
